export const COMPONENTS = Symbol('COMPONENTS');
export const CURRENT_CONTEXT = Symbol('CURRENT_CONTEXT');
export const LAST_CONTEXT = Symbol('LAST_CONTEXT');
export const META = Symbol('META');
